/**
 * Returns whether a navigation target should appear active for the current path.
 */
export function isNavItemActive(pathname, to, { end = false } = {}) {
  if (to === "/") return pathname === "/";
  if (end) return pathname === to;
  return pathname === to || pathname.startsWith(`${to}/`);
}

export function navLinkClassName(active, { compact = false } = {}) {
  const base =
    "group flex items-center gap-3 rounded-md border border-transparent px-3 py-2.5 text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary focus-visible:ring-offset-2 focus-visible:ring-offset-dark-background min-h-[44px]";
  const compactBase = compact ? " justify-center px-2" : "";
  if (active) {
    return `${base}${compactBase} bg-dark-surface-2 text-brand-primary border-dark-border`;
  }
  return `${base}${compactBase} text-dark-text-secondary hover:text-dark-text-primary hover:bg-dark-surface-1`;
}
